import * as reduxAction from 'redux-actions';
import { IActivityModel } from './Activity';

export const WEB_GET_ACTIVITY_DETAILS = "COURSE.WEB_GET_ACTIVITY_DETAILS"; 
export const GET_ACTIVITY_DETAILS_SUCCEEDED = "COURSE.GET_ACTIVITY_DETAILS_SUCCEEDED"; 
export const GET_ACTIVITY_DETAILS_FAILED = "COURSE.GET_ACTIVITY_DETAILS_FAILED"; 


export function webGetActivityDetailsAction(detailsKursusId: string):any{
    return reduxAction.createAction(WEB_GET_ACTIVITY_DETAILS)(detailsKursusId)
}

export function setActivityDetailsAction(data: IActivityModel):any{
    // { type: "", payload: {activity, themeid}  }
    return reduxAction.createAction(GET_ACTIVITY_DETAILS_SUCCEEDED)(data);
}

export function getActivityDetailsFailedAction(msg: string):any{
    return reduxAction.createAction(GET_ACTIVITY_DETAILS_FAILED)(msg);
}



// WEBPACK FOOTER //
// ./src/Entities/Activity/Activity.Actions.ts